import React from 'react'
import Modal from 'widgets/modals/Modal'
import { useRouter } from '@morningtrain/react-navigation'

function PreviewContractModal ({ contractId, ...forwardProps }, ref) {
  const router = useRouter()
  const url = router.route('app.contracts.file', { contract: contractId }) + '?' + (new Date()).getTime()

  return (
    <Modal ref={ref} {...forwardProps}>
      <iframe src={url} className='w-full' style={{ height: '60vh' }} />
    </Modal>
  )
}

export default React.forwardRef(PreviewContractModal)
